module.exports = __webpack_public_path__ + "static/media/react.9f58696a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/react.png
// module id = 177
// module chunks = 0